"use client";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Avatar,
  Button,
  Chip,
  Divider,
  IconButton,
  useTheme,
  Container,
} from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import FilterTable from "./FilterTable";
import { Pagination } from "@mui/material";
import { useState } from "react";
import { palette, theme as colorTheme} from "../../../Convoze.theme";




const primary = colorTheme('palette', 'primary').value;
const pop = colorTheme('palette', 'pop').value;
const positive = colorTheme('palette', 'positive').value;
const neutral = colorTheme('palette', 'neutral').value;
const negative = colorTheme('palette', 'negative').value;




const ClientDashboard = () => {
  const theme = useTheme();

  // Client data
  const clients = [
    {
      id: 1,
      name: "Acme Corporation",
      initials: "AC",
      plan: "Enterprise Plan",
      status: "Active",
      stats: {
        totalUsers: 182,
        minutesUsed: 28492,
        callsProcessed: 4256,
        lastActivity: "Just now",
      },
      admin: {
        name: "John Matthews",
        role: "Admin",
        avatar: "/placeholder.svg?height=40&width=40",
      },
      avatarBg: "#e6f0ff",
      avatarColor: primary,
    },
    {
      id: 2,
      name: "Widget Industries",
      initials: "WI",
      plan: "Standard Plan",
      status: "Active",
      stats: {
        totalUsers: 142,
        minutesUsed: 24182,
        callsProcessed: 3614,
        lastActivity: "2 hours ago",
      },
      admin: {
        name: "Sarah Johnson",
        role: "Admin",
        avatar: "/placeholder.svg?height=40&width=40",
      },
      avatarBg: "#f5e6ff",
      avatarColor: pop,
    },
    {
      id: 3,
      name: "Global Services",
      initials: "GS",
      plan: "Premium Plan",
      status: "Active",
      stats: {
        totalUsers: 128,
        minutesUsed: 19873,
        callsProcessed: 2953,
        lastActivity: "5 hours ago",
      },
      admin: {
        name: "Michael Wong",
        role: "Admin",
        avatar: "/placeholder.svg?height=40&width=40",
      },
      avatarBg: "#e6f7ef",
      avatarColor: positive,
    },
    {
      id: 4,
      name: "TechTron Inc.",
      initials: "TT",
      plan: "Standard Plan",
      status: "Payment Due",
      stats: {
        totalUsers: 95,
        minutesUsed: 15634,
        callsProcessed: 2311,
        lastActivity: "1 day ago",
      },
      admin: {
        name: "Robert Chen",
        role: "Admin",
        avatar: "/placeholder.svg?height=40&width=40",
      },
      avatarBg: "#ffebee",
      avatarColor: negative,
    },
    {
      id: 5,
      name: "StarCall Solutions",
      initials: "SC",
      plan: "Basic Plan",
      status: "Active",
      stats: {
        totalUsers: 58,
        minutesUsed: 12428,
        callsProcessed: 1874,
        lastActivity: "3 days ago",
      },
      admin: {
        name: "David Wilson",
        role: "Admin",
        avatar: "/placeholder.svg?height=40&width=40",
      },
      avatarBg: "#fff8e1",
      avatarColor: neutral,
    },
    {
      id: 6,
      name: "Echo Communications",
      initials: "EC",
      plan: "Enterprise Plan",
      status: "Inactive",
      stats: {
        totalUsers: 72,
        minutesUsed: 8942,
        callsProcessed: 1203,
        lastActivity: "2 weeks ago",
      },
      admin: {
        name: "Elizabeth Taylor",
        role: "Admin",
        avatar: "/placeholder.svg?height=40&width=40",
      },
      avatarBg: "#f5f5f5",
      avatarColor: "#9E9E9E",
    },
  ];

  const renderStatusChip = (status) => {
    let color = "success";
    let backgroundColor = "#e6f7ef";
    let textColor = positive;

    if (status === "Inactive") {
      color = "error";
      backgroundColor = "#ffebee";
      textColor = negative;
    } else if (status === "Payment Due") {
      color = "warning";
      backgroundColor = "#fff8e1";
      textColor = neutral;
    }

    return (
      <Chip
        label={status}
        size="small"
        sx={{
          backgroundColor,
          color: textColor,
          fontWeight: 500,
          fontSize: "0.75rem",
          height: "24px",
        }}
      />
    );
  };

  // inside ClientDashboard component
  const [page, setPage] = useState(1);
  const rowsPerPage = 3; // Number of cards per page

  const startIndex = (page - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const paginatedClients = clients.slice(startIndex, endIndex);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  return (
    <Container maxWidth="xl" sx={{ mt: 4 }}>
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 0,
        }}
      >
        <Box>
          <Typography variant="h5" component="h1" fontWeight="bold">
            User Management
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            Manage all users across the platform with role-based permissions.
          </Typography>
        </Box>
      </Box>
      <Box>
        <FilterTable />
      </Box>
      {/* ///// client Dashboard */}

      <Box sx={{ flexGrow: 1, mt: 4 }}>
        <Grid container spacing={3}>
          {clients.map((client) => (
            <Grid item xs={12} md={6} lg={4} key={client?.id}>
              <Card
                sx={{
                  height: "100%",
                  borderRadius: 2,
                  border: "1px solid #ebedf0",
                }}
              >
                <CardContent sx={{ p: 0 }}>
                  {/* Header */}
                  <Box
                    sx={{
                      p: 3,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Avatar
                        sx={{
                          bgcolor: client?.avatarBg,
                          color: client?.avatarColor,
                          width: 38,
                          height: 38,
                          mr: 2,
                          fontSize: "1rem",
                          fontWeight: "bold",
                        }}
                      >
                        {client?.initials}
                      </Avatar>
                      <Box>
                        <Typography
                          variant="body1"
                          component="div"
                          fontWeight="500"
                        >
                          {client?.name}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          {client?.plan}
                        </Typography>
                      </Box>
                    </Box>
                    <Box>{renderStatusChip(client?.status)}</Box>
                  </Box>

                  <Divider />

                  {/* Stats - First Row */}
                  <Box
                    sx={{
                      px: 3,
                      py: 2,
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Box>
                      <Typography variant="body2" color="text.secondary">
                        Total Users
                      </Typography>
                      <Typography variant="body1" fontWeight="500">
                        {client?.stats?.totalUsers}
                      </Typography>
                    </Box>
                    <Box>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        align="right"
                      >
                        Minutes Used
                      </Typography>
                      <Typography
                        variant="body1"
                        fontWeight="500"
                        align="right"
                      >
                        {client?.stats?.minutesUsed.toLocaleString()}
                      </Typography>
                    </Box>
                  </Box>

                  {/* Stats - Second Row */}
                  <Box
                    sx={{
                      px: 3,
                      py: 2,
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Box>
                      <Typography variant="body2" color="text.secondary">
                        Calls Processed
                      </Typography>
                      <Typography variant="body1" fontWeight="500">
                        {client?.stats?.callsProcessed.toLocaleString()}
                      </Typography>
                    </Box>
                    <Box>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        align="right"
                      >
                        Last Activity
                      </Typography>
                      <Typography
                        variant="body1"
                        fontWeight="500"
                        align="right"
                      >
                        {client?.stats?.lastActivity}
                      </Typography>
                    </Box>
                  </Box>

                  <Divider />

                  {/* Footer */}
                  <Box
                    sx={{
                      px: 3,
                      py: 2,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Avatar
                        src={client.admin.avatar}
                        sx={{ width: 32, height: 32, mr: 1.5 }}
                        alt={client?.admin?.Avatarname}
                      />
                      <Typography variant="subtitle2">
                        {client?.admin?.name} <br /> ({client?.admin?.role})
                      </Typography>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Button
                        variant="contained"
                        size="small"
                        sx={{
                          bgcolor: primary,
                          "&:hover": { bgcolor: primary },
                          borderRadius: "4px",
                          textTransform: "none",
                          mr: 1,
                        }}
                      >
                        Access As Admin
                      </Button>
                      {/* <IconButton size="small">
                        <MoreHorizIcon />
                      </IconButton> */}
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
        <Box display="flex" justifyContent="flex-end" mt={4}>
          <Pagination
            count={Math.ceil(clients.length / rowsPerPage)}
            page={page}
            onChange={handleChangePage}
            color="primary"
            shape="rounded"
          />
        </Box>
      </Box>
    </Container>
  );
};

export default ClientDashboard;
